import { BellIcon } from 'lucide-react';

import { useModuleRegistry } from '@/shared/registry/context';
import type { IconComponent } from '@/shared/registry/types';

import { namespaceOf } from './render';

/** The navigation icon of a module (by its id; backend ids are mapped to their frontend module). */
export function useModuleIcon(module: string): IconComponent {
  const registry = useModuleRegistry();
  const id = namespaceOf(module);
  return registry.navItems.find((item) => item.id === id)?.icon ?? BellIcon;
}
